<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    {{ dataSource.parent_site_id ? utils.getLangTerm('child-sites.plural', 'Subsites') : utils.getLangTerm('sites.plural', 'Sites') }} Selector
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-auto my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-lg-3 my-1" type="button" *ngIf="dataSource.parent_site_id" (click)="onResetList()">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button mat-raised-button color="secondary" class="mr-2 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>

  <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null" *ngIf="dataSource.multiple"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
          matTooltip="Toggle select all records in this list.">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          matTooltip="Toggle select this record.">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the name.">
        {{ dataSource.parent_site_id ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }} Name
      </th>
      <td mat-cell *matCellDef="let site">
        <mat-icon *ngIf="site?.parent_site_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
        {{ site.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef matTooltip="Toggle sorting by the address.">
        {{ dataSource.parent_site_id ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }} Address
      </th>
      <td mat-cell *matCellDef="let site">
        {{ site.location }}
      </td>
    </ng-container>

    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef>
        From
      </th>
      <td mat-cell *matCellDef="let site">
        {{ site.account.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let site">
        <button type="button" mat-button *ngIf="!site.parent_site_id && !dataSource.parent_site_id" (click)="onFilterByParentSite(site.id)" matTooltip="Show {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}." matTooltipPosition="above" >
          {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
          <mat-icon>chevron_right</mat-icon>
        </button>

        <button type="button" mat-button (click)="onSelectSite(site, $event)" matTooltip="Select this record." matTooltipPosition="above" *ngIf="!dataSource.multiple">
          Select {{ dataSource.parent_site_id ? utils.getLangTerm('child-sites.singular', 'Subsite') : utils.getLangTerm('sites.singular', 'Site') }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: listColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
    <mat-paginator
      class="my-2 ml-1 mr-2"
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>

  <button
    *ngIf="dataSource.multiple"
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSelectSites()"
    mat-dialog-close
    [disabled]="!dataSource.multiple && !dataSource.selection.hasValue()">
    Select {{ dataSource.parent_site_id ? utils.getLangTerm('child-sites.plural', 'Subsites') : utils.getLangTerm('sites.plural', 'Sites') }}
  </button>
</mat-dialog-actions>
